import { useEffect } from 'react';
import { setPlayAlongCountInUngraded } from 'Utils/playAlongCountIn';

/**
 * Feeds the player's effective grading into the count-in while a play surface
 * is mounted: an ungraded player's playback starts on its own after a
 * count-in, a graded player's waits for the first note.
 */
export const useCountInGradingInput = (graded: boolean): void => {
  useEffect(() => {
    setPlayAlongCountInUngraded(!graded);
    return () => setPlayAlongCountInUngraded(null);
  }, [graded]);
};
